module.exports = __webpack_public_path__ + "static/media/Host Asset 5.036a4df7.svg";